<div class="lv-login-box">
  <div class="lv-login-box__header"></div>
  <div class="lv-login-box__content">
    <div class="lv-login-box__title" translate>password-reset-token-expired.title</div>
    <div class="error-message" translate>password-reset-token-expired.error-message</div>
    <div class="message" translate>password-reset-token-expired.description</div>
    <a routerLink="/auth/password/new" class="button" translate>password-reset-token-expired.button</a>
  </div>
</div>

<lv-copyright></lv-copyright>
